import { ApiRoute, VstarPidResp, VstarPidRespSchema, getApiRoute } from "@humanex/interfaces";

import { ApiClientConfig, BaseApiClient } from "./base-client";

export class PartnerApiClient extends BaseApiClient {
  constructor(config: ApiClientConfig) {
    super({
      ...config,
      baseEndpoint: getApiRoute(ApiRoute.PARTNER),
      requireAuth: true
    });
  }

  async getVstarPid(): Promise<VstarPidResp> {
    return this.get("user/vstar/pid", VstarPidRespSchema);
  }

  async getVstarPidById(userId: string): Promise<VstarPidResp> {
    return this.get(`user/vstar/pid/${userId}`, VstarPidRespSchema);
  }
}
